module.exports = {
lines:[
    {
        chunks: {
            line_0_begin: {
                x: 17,
                y: 304
            },
            line_0_cell_0: {
                x: 24,
                y: 304
            },
            line_0_cell_1: {
                x: 220,
                y: 304
            },
            line_0_cell_2: {
                x: 416,
                y: 304
            },
            line_0_cell_3: {
                x: 612,
                y: 304
            },
            line_0_cell_4: {
                x: 808,
                y: 304
            },
            line_0_end: {
                x: 999,
                y: 304
            },
            line_0_gap_0: {
                x: 215,
                y: 304
            },
            line_0_gap_1: {
                x: 411,
                y: 304
            },
            line_0_gap_2: {
                x: 607,
                y: 304
            },
            line_0_gap_3: {
                x: 803,
                y: 304
            }
        },
        trajectory: [
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_1_begin: {
                x: 17,
                y: 114
            },
            line_1_cell_0: {
                x: 24,
                y: 114
            },
            line_1_cell_1: {
                x: 220,
                y: 114
            },
            line_1_cell_2: {
                x: 416,
                y: 114
            },
            line_1_cell_3: {
                x: 612,
                y: 114
            },
            line_1_cell_4: {
                x: 808,
                y: 114
            },
            line_1_end: {
                x: 999,
                y: 114
            },
            line_1_gap_0: {
                x: 215,
                y: 114
            },
            line_1_gap_1: {
                x: 411,
                y: 114
            },
            line_1_gap_2: {
                x: 607,
                y: 114
            },
            line_1_gap_3: {
                x: 803,
                y: 114
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_2_begin: {
                x: 17,
                y: 494
            },
            line_2_cell_0: {
                x: 24,
                y: 494
            },
            line_2_cell_1: {
                x: 220,
                y: 494
            },
            line_2_cell_2: {
                x: 416,
                y: 494
            },
            line_2_cell_3: {
                x: 612,
                y: 494
            },
            line_2_cell_4: {
                x: 808,
                y: 494
            },
            line_2_end: {
                x: 999,
                y: 494
            },
            line_2_gap_0: {
                x: 215,
                y: 494
            },
            line_2_gap_1: {
                x: 411,
                y: 494
            },
            line_2_gap_2: {
                x: 607,
                y: 494
            },
            line_2_gap_3: {
                x: 803,
                y: 494
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_3_begin: {
                x: 17,
                y: 74
            },
            line_3_cell_0: {
                x: 24,
                y: 74
            },
            line_3_cell_1: {
                x: 220,
                y: 239
            },
            line_3_cell_2: {
                x: 416,
                y: 430
            },
            line_3_cell_3: {
                x: 632,
                y: 234
            },
            line_3_cell_4: {
                x: 822,
                y: 74
            },
            line_3_end: {
                x: 999,
                y: 74
            },
            line_3_gap_0: {
                x: 178,
                y: 214
            },
            line_3_gap_1: {
                x: 368,
                y: 404
            },
            line_3_gap_2: {
                x: 607,
                y: 404
            },
            line_3_gap_3: {
                x: 803,
                y: 214
            }
        },
        trajectory: [
            0,
            1,
            2,
            1,
            0
        ]
    },
    {
        chunks: {
            line_4_begin: {
                x: 6,
                y: 538
            },
            line_4_cell_0: {
                x: 24,
                y: 430
            },
            line_4_cell_1: {
                x: 240,
                y: 234
            },
            line_4_cell_2: {
                x: 430,
                y: 142
            },
            line_4_cell_3: {
                x: 612,
                y: 247
            },
            line_4_cell_4: {
                x: 808,
                y: 443
            },
            line_4_end: {
                x: 999,
                y: 538
            },
            line_4_gap_0: {
                x: 215,
                y: 404
            },
            line_4_gap_1: {
                x: 411,
                y: 214
            },
            line_4_gap_2: {
                x: 562,
                y: 214
            },
            line_4_gap_3: {
                x: 752,
                y: 404
            }
        },
        trajectory: [
            2,
            1,
            0,
            1,
            2
        ]
    },
    {
        chunks: {
            line_5_begin: {
                x: 23,
                y: 158
            },
            line_5_cell_0: {
                x: 24,
                y: 158
            },
            line_5_cell_1: {
                x: 220,
                y: 158
            },
            line_5_cell_2: {
                x: 416,
                y: 300
            },
            line_5_cell_3: {
                x: 695,
                y: 158
            },
            line_5_cell_4: {
                x: 808,
                y: 158
            },
            line_5_gap_0: {
                x: 215,
                y: 158
            },
            line_5_gap_1: {
                x: 313,
                y: 214
            },
            line_5_gap_2: {
                x: 503,
                y: 404
            },
            line_5_gap_3: {
                x: 613,
                y: 214
            }
        },
        trajectory: [
            0,
            0,
            1,
            0,
            0
        ]
    },
    {
        chunks: {
            line_6_begin: {
                x: 23,
                y: 452
            },
            line_6_cell_0: {
                x: 24,
                y: 452
            },
            line_6_cell_1: {
                x: 220,
                y: 403
            },
            line_6_cell_2: {
                x: 416,
                y: 213
            },
            line_6_cell_3: {
                x: 692,
                y: 403
            },
            line_6_cell_4: {
                x: 808,
                y: 452
            },
            line_6_gap_0: {
                x: 215,
                y: 452
            },
            line_6_gap_1: {
                x: 316,
                y: 304
            },
            line_6_gap_2: {
                x: 506,
                y: 209
            },
            line_6_gap_3: {
                x: 613,
                y: 307
            }
        },
        trajectory: [
            2,
            2,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_7_begin: {
                x: 20,
                y: 264
            },
            line_7_cell_0: {
                x: 24,
                y: 213
            },
            line_7_cell_1: {
                x: 220,
                y: 31
            },
            line_7_cell_2: {
                x: 416,
                y: 31
            },
            line_7_cell_3: {
                x: 612,
                y: 31
            },
            line_7_cell_4: {
                x: 841,
                y: 213
            },
            line_7_end: {
                x: 999,
                y: 264
            },
            line_7_gap_0: {
                x: 165,
                y: 159
            },
            line_7_gap_1: {
                x: 411,
                y: 31
            },
            line_7_gap_2: {
                x: 607,
                y: 31
            },
            line_7_gap_3: {
                x: 803,
                y: 158
            }
        },
        trajectory: [
            1,
            0,
            0,
            0,
            1
        ]
    },
    {
        chunks: {
            line_8_begin: {
                x: 14,
                y: 348
            },
            line_8_cell_0: {
                x: 24,
                y: 348
            },
            line_8_cell_1: {
                x: 220,
                y: 445
            },
            line_8_cell_2: {
                x: 416,
                y: 581
            },
            line_8_cell_3: {
                x: 612,
                y: 450
            },
            line_8_cell_4: {
                x: 848,
                y: 348
            },
            line_8_end: {
                x: 999,
                y: 348
            },
            line_8_gap_0: {
                x: 162,
                y: 404
            },
            line_8_gap_1: {
                x: 411,
                y: 581
            },
            line_8_gap_2: {
                x: 607,
                y: 581
            },
            line_8_gap_3: {
                x: 803,
                y: 404
            }
        },
        trajectory: [
            1,
            2,
            2,
            2,
            1
        ]
    },
    {
        chunks: {
            line_9_begin: {
                x: 13,
                y: 583
            },
            line_9_cell_0: {
                x: 24,
                y: 467
            },
            line_9_cell_1: {
                x: 277,
                y: 271
            },
            line_9_cell_2: {
                x: 416,
                y: 268
            },
            line_9_cell_3: {
                x: 612,
                y: 213
            },
            line_9_cell_4: {
                x: 808,
                y: 41
            },
            line_9_end: {
                x: 999,
                y: 41
            },
            line_9_gap_0: {
                x: 215,
                y: 404
            },
            line_9_gap_1: {
                x: 411,
                y: 268
            },
            line_9_gap_2: {
                x: 607,
                y: 268
            },
            line_9_gap_3: {
                x: 731,
                y: 137
            }
        },
        trajectory: [
            2,
            1,
            1,
            1,
            0
        ]
    }
]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 24
// module chunks = 0